module.exports = __webpack_public_path__ + "static/media/icon-missing.34dae91e.svg";